function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => removeItem(data_line));
    });
    
//     document.querySelectorAll('.quantity__input').forEach(function(cartQtyUpdate){
//       var data_id = cartQtyUpdate.dataset.variant;   
//       var data_qty = cartQtyUpdate.value;
//       console.log('data_qty--',data_qty);
//       cartQtyUpdate.addEventListener('change',(evt) => updateQuantity(data_id, data_qty));
//     });
        
    /*document.querySelectorAll('.custom-add-to-cart').forEach(function(variantsId){
      var data_variantsId = variantsId.dataset.id;          
      variantsId.addEventListener('click',(evt) => custom_addtocart(data_variantsId));
    });*/

      document.querySelectorAll('.shoppingcart').forEach(function(cartButton){
        cartButton.addEventListener('click',function(e){
          document.querySelector('body').classList.add('open-drawer');
          document.querySelector(".cart-sidebar").style.display="";
          document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter'); 
          document.querySelector('.cart-drawer-close').focus();
        });
      });
  
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector(".cart-sidebar").style.display="none";
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter');
      });
    });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      var cart_total = data.total_price;
      document.querySelectorAll('.cart-count-bubble').forEach(function(e){
        e.innerHTML = cart_count;
      });
      if(cart_count > 0){
        var countDiv = document.querySelector('.cart-count-header');
        var countDivDesktop = document.querySelector('.cart-item-count');
        var totalCount = document.querySelector('.cart-total-count');
        
        var hasCustomer = document.querySelector('.header_cartCount');
        if(countDiv != undefined){ 
          // countDiv.innerHTML = cart_count;
          if(cart_count > 1){
            countDiv.innerHTML = cart_count + ' items';
          }else{
            countDiv.innerHTML = cart_count + ' item';
          }  
        }
   
        if(totalCount != undefined){
          totalCount.innerHTML = theme.Currency.formatMoney(cart_total, theme.settings.moneyFormat);
        }
       
        if(countDivDesktop != undefined){
          if(cart_count > 1){
            countDivDesktop.innerHTML = cart_count + ' (items)';
          }else{
            countDivDesktop.innerHTML = cart_count + ' (item)';
          }  
        }
        
      }else{
      	// var countDiv = document.querySelector('.cart-count-bubble').querySelectorAll('[aria-hidden]')[0];
        var countDiv = document.querySelector('.cart-count-header');
        var totalCount = document.querySelector('.cart-total-count');
        var countDivDesktop = document.querySelector('.cart-item-count');
        if(countDiv != undefined){
          countDiv.innerHTML = 0;
        }
        if(countDivDesktop != undefined){
          countDivDesktop.innerHTML = 0 + ' item';
        }
        if(totalCount != undefined){
          totalCount.innerHTML = 0;
        }
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
    setTimeout(() => {
    document.querySelector('.cart-drawer-close').focus();
    },1000);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateQuantity(data_index, data_qty) {
  let focusedElement = document.activeElement;
  console.log(focusedElement,"onfocus");
  var inputId = document.activeElement.closest('.quantity').querySelector('.quantity__input').id;
  console.log(inputId,"id");
  var upId = data_index;
  var upQTY = data_qty;
  updateCartItem(upId, upQTY)	
  
  async function updateCartItem(id, qty) {
    const result = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: id,
        quantity: qty
      })
    })
    .then((data) => {
      if(data.status === 200){
        load_cart();
        //console.log("Done");
      }else{
        console.log('Cart drawer quantity is not updated.');
      }
    });
  }
}
function custom_addtocart(variantsId) {
  
  //console.log("Clicked");
	//console.log(variantsId);
  var pbTempId = Number(variantsId);
  var pbTempQTY = 1;
  addItem(pbTempId, pbTempQTY)

  async function addItem(variantId, quantity) {
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then((data) => {
      if(data.status === 200){  
        
        load_cart();
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
        //console.log("Done");
      }else{
        console.log('cart-drawer error');
      }
    });
  }

}
